export const APP_BUILD_VERSION = '9c3a30b';
